__turbopack_context__.v({
  "root": "Anchor-module__2F9l8G__root",
});
